import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { InventoryEntities } from 'client/data/models/inventory';
import { WARRANTY_MAX_TYPE } from 'site-modules/shared/constants/inventory/warranty';
import { numberWithCommas } from 'site-modules/shared/utils/string';

export function WarrantyConditions({
  warrantyItem: { maxYearsType, maxMileageType, maxYears, maxMileage },
  className = '',
  delimiter = '/',
  weight = 'medium',
}) {
  const yearValuesMap = {
    [WARRANTY_MAX_TYPE.LIMITED]: `${maxYears} yr`,
    [WARRANTY_MAX_TYPE.UNLIMITED]: `unlimited yr`,
  };

  const mileageValuesMap = {
    [WARRANTY_MAX_TYPE.LIMITED]: `${numberWithCommas(Number(maxMileage))} mi`,
    [WARRANTY_MAX_TYPE.UNLIMITED]: `unlimited mi`,
  };

  return (
    <span className={classnames(`d-flex flex-wrap justify-content-end fw-${weight}`, className)}>
      <span className="me-0_25">{yearValuesMap[maxYearsType] || '-'}</span>
      {delimiter}
      <span className="ms-0_25">{mileageValuesMap[maxMileageType] || '-'}</span>
    </span>
  );
}

WarrantyConditions.propTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
  delimiter: PropTypes.node,
  className: PropTypes.string,
  weight: PropTypes.oneOf(['normal', 'medium']),
};
